import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';
import { AspectRatioWrapper, NamedLink } from '../../../components';
import { useConfiguration } from '../../../context/configurationContext';
import { getCloudinaryBaseUrl } from '../../../util/cloudinary';

import css from './SectionSearchByCategories.module.css';

const IMAGE_ASPECT_WIDTH = 4;
const IMAGE_ASPECT_HEIGHT = 3;

const MAX_SUBCATEGORIES = 4;

const SingleCategory = props => {
  const { category } = props;
  const { name, subcategories } = category;

  const cloudinaryBaseUrl = getCloudinaryBaseUrl({
    variantPrefix: 'landscape-crop2x',
  });
  const imagePath = `${cloudinaryBaseUrl}/categories/categoryLevel1/${category.id}.jpg`;

  return (
    <div className={css.category}>
      <AspectRatioWrapper width={IMAGE_ASPECT_WIDTH} height={IMAGE_ASPECT_HEIGHT}>
        <img className={css.categoryImage} src={imagePath} alt={name} />
      </AspectRatioWrapper>
      <NamedLink
        className={css.categoryTitle}
        name="SearchPage"
        to={{
          search: `?pub_categoryLevel1=${category.id}`,
        }}
      >
        {name}
      </NamedLink>
      <ul className={css.subcategories}>
        {subcategories.slice(0, MAX_SUBCATEGORIES).map(subcategory => (
          <li key={subcategory.id} className={css.subcategory}>
            <NamedLink
              name="SearchPage"
              to={{
                search: `?pub_categoryLevel1=${category.id}&pub_categoryLevel2=${subcategory.id}`,
              }}
            >
              {subcategory.name}
            </NamedLink>
          </li>
        ))}
        <li className={classNames(css.subcategory, css.subcategoryViewAll)}>
          <NamedLink name="SearchPage" to={{ search: `?pub_categoryLevel1=${category.id}` }}>
            <FormattedMessage id="LandingPage.SectionSearchByCategories.viewAllSubcategories" />
          </NamedLink>
        </li>
      </ul>
    </div>
  );
};

const SectionSearchByCategories = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  const config = useConfiguration();
  const categoryConfiguration = config.categoryConfiguration;
  const { categories: listingCategoriesConfig } = categoryConfiguration;

  return (
    <div className={classes}>
      <h2 className={css.title}>
        <FormattedMessage id="LandingPage.SectionSearchByCategories.title" />
      </h2>
      <div className={css.categories}>
        {listingCategoriesConfig.map(category => (
          <SingleCategory key={category.id} category={category} />
        ))}
      </div>
    </div>
  );
};

const { string } = PropTypes;

SectionSearchByCategories.defaultProps = {
  className: null,
  rootClassName: null,
};

SectionSearchByCategories.propTypes = {
  className: string,
  rootClassName: string,
};

export default SectionSearchByCategories;
